import "./Images.css"

export default function Images({props}){

    return(
        <div id = "OutsideBox">
            <h5 style = {{marginTop: "10%"}}> {props.title}</h5>
            <div className="container">
                <div className="row">
                    <div className="col-lg-12 box" style = {{height: 300, marginTop: "10%"}}>
                        <div>
                            <img src={props.image1} width="200" height= "150" alt=""/>
                            <p style = {{marginTop: "10%"}}><b>{props.type}</b></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}